export default __webpack_public_path__ + "static/media/upgrade-pot.51f20552.svg";